<template>
  <WidgetScrollCard header="Reminders" icon="bell" :height>
    <template #badges>
      <Badge class="rounded-full" size="small" severity="danger" :value="todaysReminders.currentReminders.length"></Badge>
      <Badge class="rounded-full" size="small" severity="warning" :value="todaysReminders.upcomingReminders.length"></Badge>
    </template>
    <template #content>
      <div v-if="allReminders.length !== 0" class="flex flex-col gap-3">
        <div v-for="(projectReminder, index) in allReminders">
          <Card pt:body:class="p-2!">
            <template #content>
              <div class="flex flex-row gap-5">
                <div class="flex flex-col w-full">
                  <div class="flex flex-row gap-1 text-surface-500 dark:text-surface-400">
                    <i class="text-sm! my-auto pi pi-clock" :class="projectReminder.passed ? 'text-danger-500' : 'text-warning-500'"></i>
                    <p class="text-sm font-bold ml-1 my-auto" :class="projectReminder.passed ? 'text-danger-500' : 'text-warning-500'">
                      {{ projectReminder.reminderDate != null ? format(projectReminder.reminderDate, "MM/dd/yyyy") : "" }}
                    </p>
                  </div>
                  <div class="w-fit text-sm">
                    {{ getProjectName(projectReminder.projectId) }}
                  </div>
                  <h1 class="font-bold text-lg -my-1">{{ projectReminder.reminder.reminderTitle }}</h1>
                  <p class="text-surface-500 dark:text-surface-400 text-xs">{{ projectReminder.reminder.reminderText }}</p>
                </div>
                <Button
                  v-tooltip.top="'Dismiss'"
                  class="my-auto h-10! w-10! p-2! mr-4 shrink-0! text-xl font-bold border-2! hover:w-11! hover:h-11! duration-200 ease-in-out"
                  icon="pi pi-check"
                  rounded
                  outlined
                  @click="dismiss(projectReminder, index)"
                ></Button>
              </div>
            </template>
          </Card>
        </div>
      </div>
      <div v-else class="h-full flex">
        <p class="text-center font-bold w-full mt-28">---No Reminders to Show---</p>
      </div>
    </template>
  </WidgetScrollCard>
</template>

<script setup lang="ts">
import { dismissReminder } from "@/services/ReminderService";
import type { ProjectSummary } from "@/types/Projects";
import type { ProjectReminder, TodaysReminders } from "@/types/Reminder";
import { format } from "date-fns";

//ORIGINALLY HAD SPLIT THESE UP, BUT JUST COMBINE INTO ONE LIST
const todaysReminders = defineModel<TodaysReminders>("todaysReminders", { required: true });
const allReminders = computed<ProjectReminder[]>(() => {
  return todaysReminders.value.currentReminders.concat(todaysReminders.value.upcomingReminders);
});

interface Props {
  projects: ProjectSummary[];
  passed: boolean;
  height: string;
}
const props = defineProps<Props>();

const getProjectName = (projectId: string): string => {
  const project = props.projects.find((project: ProjectSummary) => project.projectId === projectId);
  return project != null ? project.projectName : "";
};

const dismiss = (projectReminder: ProjectReminder, index: number): void => {
  dismissReminder(projectReminder).then((isSuccess: boolean) => {
    if (isSuccess) {
      todaysReminders.value.currentReminders = todaysReminders.value.currentReminders.filter(
        (reminder: ProjectReminder) => reminder.projectReminderId !== projectReminder.projectReminderId
      );
      todaysReminders.value.upcomingReminders = todaysReminders.value.upcomingReminders.filter(
        (reminder: ProjectReminder) => reminder.projectReminderId !== projectReminder.projectReminderId
      );
    }
  });
};
</script>
